import {mapState, mapActions} from 'vuex'
import {ssGet, view_is_edit} from "./utils";
import {confirm} from "../api";
export const checkAuth = {
    data() {
        return {
            showTabList: [],
            auth_loading: true
        }
    },
    computed: {
        ...mapState('homeData', [
            'now_auth'
        ])
    },
    mounted() {
        this.changeTab()
    },
    methods: {
        ...mapActions('homeData', {
            getAuthorityData: 'getAuthorityData'
        }),
        showTab(item) {
            let list = item.decide;
            if (!list || list.length === 0) return true;
            let tab = false;
            list.forEach(v => {
                this.now_auth.forEach(e => {
                    if (e.indexOf(v) > -1) {
                        tab = true
                    }
                });
            });
            return tab;
        },
        changeTab() {
            if(this.now_auth && this.now_auth.length > 0) {
                this.continueTab()
            } else {
                this.getAuthorityData().then(() => {
                    this.continueTab()
                })
            }
        },
        continueTab() {
            let list = [];
            this.tabsList.forEach(v => {
                if(this.showTab(v)) {
                    list.push(v)
                }
            });
            this.showTabList = list;
            this.componentId = list[0] ? list[0].name : '';

            this.auth_loading = false
        },

        beforeLeave(activeName, oldActiveName) {
            let is_edit = ssGet('view_is_edit');
            const that = this;
            if(is_edit == '2') {
                // 正在修改
                confirm('页面存在未保存数据，确定要离开当前页吗？',{
                    title: '提示',
                    conText: '确认',
                    canText: '取消',
                    showClose: false
                }).then(() => {
                    view_is_edit(1);
                    that.componentId = activeName
                }).catch(() => {
                    that.componentId = oldActiveName
                })
            } else {
                return true
            }
            return false
        },
    }
};
export const checkAuthSetting = {
    data() {
        return {
            showMenuList: [],
            auth_loading: true
        }
    },
    computed: {
        ...mapState('homeData', [
            'now_auth'
        ])
    },
    mounted() {
        this.changeTab()
    },
    methods: {
        ...mapActions('homeData', {
            getAuthorityData: 'getAuthorityData'
        }),
        showTab(item) {
            let list = item.decide;
            if (!list || list.length === 0) return true;
            let tab = false;
            list.forEach(v => {
                this.now_auth.forEach(e => {
                    if (e.indexOf(v) > -1) {
                        tab = true
                    }
                });
            });
            return tab;
        },
        changeTab() {
            if(this.now_auth && this.now_auth.length > 0) {
                this.continueTab()
            } else {
                this.getAuthorityData().then(() => {
                    this.continueTab()
                })
            }

        },
        continueTab() {
            let list = [];
            this.menuList.forEach(v => {
                if(this.showTab(v)) {
                    list.push(v)
                }
            });
            this.showMenuList = list;
            if(!list[0]) {
                this.auth_loading = false
                return
            }
            this.componentId = list[0].path;
            this.activeIndex = list[0].index;

            this.auth_loading = false
        }
    }
};
export const authShow = {
    computed: {
        ...mapState('homeData', [
            'now_auth'
        ])
    },
    methods: {
        // 左侧导航栏权限验证
        sideTabShow(item) {
            // return true
            if(!item) return false;
            let list = item.decide;
            return this.showTab(list)
        },
        showTab(list) {
            if (list.length === 0) return true;
            let tab = false;
            this.now_auth.forEach(v => {
                list.forEach(e => {
                    if (v.indexOf(e) > -1) {
                        tab = true
                    }
                })
            });
            return tab;
        },
    }
};
export const checkPower = {
    computed: {
        ...mapState('homeData', [
            'now_auth'
        ]),
        power_edit() {
            return !this.edit_code || this.now_auth.indexOf(this.edit_code) > -1
        },
        power_look() {
            return !this.look_code || this.now_auth.indexOf(this.look_code) > -1
        },
        power_delete() {
            return !this.delete_code || this.now_auth.indexOf(this.delete_code) > -1
        },
        power_browse() {
            return !this.browse_code || this.now_auth.indexOf(this.browse_code) > -1
        },
        power_merge () {
            return !this.merge_code || this.now_auth.indexOf(this.merge_code) > -1
        },
        power_export () {
            return !this.export_code || this.now_auth.indexOf(this.export_code) > -1
        },
    },
};